<div class="d-flex group-item" *ngIf="group.id > 0">
    <div class="r"></div>
    <div class="p-2 star" style="width: 2%;">
        <!-- <mat-icon class="icon-size-20" aria-hidden="false" aria-label="Star icon">star_border</mat-icon> -->
    </div>
    <div class="p-2 name" style="width: 43%;"
        [routerLink]="['/groups', group.id]">
        {{group.name}}
        <div class="description">{{description}}</div>
    </div>
    <div class="p-2 users flex-grow-1" style="width: 10%;">
        <div class="group-approvers">
            <div class="approver-avatar" (click)="openApproversPopup()">
                <mat-icon class="size-28 add-more">add_circle_outline</mat-icon>
            </div>
            <div class="approver-avatar" *ngFor="let approver of approvers">
                <div [title]="approver.fullName"><one-avatar size="28" [imageUrl]="approver.avatarUrl"></one-avatar></div>
            </div>
            <div class="approver-avatar more size-28" *ngIf="moreApprover != 0">
                <div class="remain">{{moreApprover}}</div>
            </div>
        </div>
    </div>
    <div class="p-2 ma flex-grow-1" style="width: 10%;">
        <mat-slide-toggle class="full" labelPosition="before" color="warn" disabled="true" [(ngModel)]="requireDM">
        </mat-slide-toggle>
    </div>
    <div class="p-2 type flex-grow-1" style="width: 5%;">{{friendlyApprovalName}}</div>
    <div class="p-2 sla flex-grow-1" style="width: 5%;" [innerHtml]="sla"></div>
    <div class="p-2 status flex-grow-1" style="width: 5%;">
        <mat-slide-toggle class="full" labelPosition="before" color="warn"
                            [(ngModel)]="status"
                            (change)="onStatusChange($event)">
        </mat-slide-toggle>
    </div>
</div>
